import {
  REMOVE_LISTS,
  SIGNATURE_IMAGE_LOAD_COMPANY_LIST,
  SIGNATURE_IMAGE_LOAD_TABLE_LOG,
  SIGNATURE_IMAGE_GET_DETAIL,
  SIGNATURE_IMAGE_CREATE,
  SIGNATURE_IMAGE_UPDATE,
  SIGNATURE_IMAGE_DELETE,
  SIGNATURE_IMAGE_LOAD_USER,
} from './actions'

const initialState = {
  // *load ข้อมูลบริษัท
  company_list: [],
  check_company_list: false,

  // *table log
  check_table_log: false,
  table_log_list: [],
  table_log_total: 0,

  // *get detail
  check_detail: false,
  detail_response: {},

  // *create
  check_create: false,
  create_response: {},

  // *update
  check_update: false,
  update_response: {},

  // *delete
  check_delete: false,
  delete_response: {},

  // *load ข้อมูล user
  check_user: false,
  user_list: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState

    case SIGNATURE_IMAGE_LOAD_COMPANY_LIST.REQUEST:
      return {
        ...state,
        company_list: [],
        check_company_list: true,
      }
    case SIGNATURE_IMAGE_LOAD_COMPANY_LIST.SUCCESS:
      return {
        ...state,
        company_list: action.payload.lists || [],
        check_company_list: false,
      }

    case SIGNATURE_IMAGE_LOAD_TABLE_LOG.REQUEST:
      return {
        ...state,
        check_table_log: true,
      }
    case SIGNATURE_IMAGE_LOAD_TABLE_LOG.SUCCESS:
      return {
        ...state,
        check_table_log: false,
        table_log_list: action.payload.lists.data || [],
        table_log_total: action.payload.lists.total || 0,
      }
    case SIGNATURE_IMAGE_GET_DETAIL.REQUEST:
      return {
        ...state,
        check_detail: true,
        detail_response: {},
      }
    case SIGNATURE_IMAGE_GET_DETAIL.SUCCESS:
      return {
        ...state,
        check_detail: false,
        detail_response: action.payload.lists || {},
      }

    case SIGNATURE_IMAGE_CREATE.REQUEST:
      return {
        ...state,
        check_create: true,
        create_response: {},
      }
    case SIGNATURE_IMAGE_CREATE.SUCCESS:
      return {
        ...state,
        check_create: false,
        create_response: action.payload.lists || {},
      }

    case SIGNATURE_IMAGE_UPDATE.REQUEST:
      return {
        ...state,
        check_update: true,
        update_response: {},
      }
    case SIGNATURE_IMAGE_UPDATE.SUCCESS:
      return {
        ...state,
        check_update: false,
        update_response: action.payload.lists || {},
      }

    case SIGNATURE_IMAGE_DELETE.REQUEST:
      return {
        ...state,
        check_delete: true,
        delete_response: {},
      }

    case SIGNATURE_IMAGE_DELETE.SUCCESS:
      return {
        ...state,
        check_delete: false,
        delete_response: action.payload.lists || {},
      }

    case SIGNATURE_IMAGE_LOAD_USER.REQUEST:
      return {
        ...state,
        check_user: true,
        user_list: [],
      }
    case SIGNATURE_IMAGE_LOAD_USER.SUCCESS:
      return {
        ...state,
        check_user: false,
        user_list: action.payload.lists || [],
      }

    default:
      return state
  }
}
